<template>
  <main class="hall-schemes-page page">
    <BreadcrumbsComponent title="Схемы залов" />
    <div class="container-padding">
      <div v-if="hallSchemes && hallSchemes.length" class="hall-schemes-page__inner">
        <LoadingIndicator v-if="loading" title="Загрузка" />
        <div v-if="!loading" class="hall-schemes-page__content">
          <HallSchemeCardComponent v-for="(scheme, i) in hallSchemes" :key="i" :scheme="scheme" />
        </div>
      </div>
      <h2 v-else class="no-info">В данный момент информация отсутствует</h2>
    </div>
  </main>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import HallSchemeCardComponent from "./components/HallSchemeCardComponent.vue";
import HALL_SCHEMES_PAGE from "gql/pages/HallSchemesPage.graphql";
import LoadingIndicator from "components/LoadingIndicator.vue";

export default {
  name: "HallSchemesPage",
  metaInfo: {
    title: "Схемы залов",
  },
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: HALL_SCHEMES_PAGE,
      })
      .then(({ data }) => {
        store.dispatch("hallSchemes/save", data);
      });
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    hallSchemes() {
      return this.$store.state.hallSchemes.hall_schemes;
    },
  },
  components: {
    LoadingIndicator,
    BreadcrumbsComponent,
    HallSchemeCardComponent,
  },
};
</script>

<style lang="stylus">
.hall-schemes-page {

  &__inner {
    padding 50px 0 0 0
    display grid
    grid-gap 50px
  }

  &__content {
    display grid
    grid-template-columns 1fr 1fr
    grid-gap 30px 20px
    +below(900px) {
      grid-template-columns 1fr
    }
  }
}
</style>
